import { setSelectedBranch, setLocation } from "../slices/branchFinderSlice";

export const selectBranch = (branch) => (dispatch) => {
  dispatch(setSelectedBranch(branch));
};

export const updateLocation = (location) => (dispatch) => {
  dispatch(setLocation(location));
};
